import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Assessments-AssessmentView', [
  'previousAttemptsTable',
  'previousFeedbackPanel',
  'previousFeedbackCard',
  'editAndInsertButton',
  'emptyState',
  'feedbackTextarea',
  'feedbackSaveStatus',
]);
